import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { ServiceTemplateMapping } from '../models/service-template-map-model';

@Injectable({
  providedIn: 'root',
})
export class ServiceTemplateMappingService {
  constructor(private http: HttpClient) {}

  lFN_GetServiceTemplateMappingList() {
    return this.http.get(`${environment.ROOT_URL}/service-temp-mapping`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_SaveServiceTemplateMapping(payload: ServiceTemplateMapping): Observable<HttpResponse<any>> {
    return this.http.post<any>(
      `${environment.ROOT_URL}/service-temp-mapping`, payload,
      {
        observe: 'response',
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  lFN_GetServiceTempMapById(serviceTempId: number) {
    return this.http.get(`${environment.ROOT_URL}/service-temp-mapping/service-temp-id/${serviceTempId}`, {
      withCredentials: false,
      responseType: 'text',
      observe: 'response',
    });
  }

  lFN_ToggleServiceTempMapStatus(serviceTempId: number) {
    return this.http.patch(
      `${environment.ROOT_URL}/service-temp-mapping/status/${serviceTempId}`, {}, { observe: 'response', responseType: 'json' }
    );
  }

}
